"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var get_1 = __importDefault(require("lodash/get"));
var has_1 = __importDefault(require("lodash/has"));
var isArray_1 = __importDefault(require("lodash/isArray"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var isObject_1 = __importDefault(require("lodash/isObject"));
var merge_1 = __importDefault(require("lodash/merge"));
var omit_1 = __importDefault(require("lodash/omit"));
var set_1 = __importDefault(require("lodash/set"));
var unset_1 = __importDefault(require("lodash/unset"));
var InputHandlers_1 = require("./InputHandlers");
var FormManager = (function () {
    function FormManager(state, stateSetter) {
        this.state = state;
        this.stateSetter = stateSetter;
        this.values = {};
        this.initialValues = {};
        this.formattedValues = {};
        this.touched = {};
        this.valid = {};
        this.copyState(state);
    }
    FormManager.prototype.setState = function (value) {
        var _this = this;
        this.stateSetter(function (state) {
            var newState = isFunction_1.default(value) ? value(state) : value;
            _this.copyState(newState);
            return newState;
        });
    };
    FormManager.prototype.copyState = function (state) {
        this.values = state.values;
        this.formattedValues = state.formattedValues;
        this.initialValues = state.initialValues;
        this.valid = state.valid;
        this.touched = state.touched;
    };
    FormManager.prototype.text = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'text';
        return this.input(options);
    };
    FormManager.prototype.password = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'password';
        return this.input(options);
    };
    FormManager.prototype.number = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'number';
        options.inputHandler = merge_1.default({}, InputHandlers_1.numberHandler, options.inputHandler);
        return this.input(options);
    };
    FormManager.prototype.email = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'email';
        return this.input(options);
    };
    FormManager.prototype.url = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'url';
        return this.input(options);
    };
    FormManager.prototype.color = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'color';
        return this.input(options);
    };
    FormManager.prototype.date = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'date';
        return this.input(options);
    };
    FormManager.prototype.datetimeLocal = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'datetime-local';
        return this.input(options);
    };
    FormManager.prototype.month = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'month';
        return this.input(options);
    };
    FormManager.prototype.search = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'search';
        return this.input(options);
    };
    FormManager.prototype.tel = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'tel';
        return this.input(options);
    };
    FormManager.prototype.time = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'time';
        return this.input(options);
    };
    FormManager.prototype.week = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'week';
        return this.input(options);
    };
    FormManager.prototype.input = function (options) {
        options.inputHandler = merge_1.default({}, InputHandlers_1.basicHandler, options.inputHandler);
        return {
            type: options.type,
            name: options.name,
            value: this.getInputValue(options.name, options.inputHandler),
            onChange: this.inputChangeHandler(options),
            onFocus: this.basicFocusHandler(options),
            onBlur: this.inputBlurHandler(options),
            onKeyDown: this.inputKeyDownHandler(options),
        };
    };
    FormManager.prototype.textarea = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.inputHandler = merge_1.default({}, InputHandlers_1.basicHandler, options.inputHandler);
        return {
            name: name,
            value: this.getInputValue(name, options.inputHandler),
            onChange: this.inputChangeHandler(options),
            onFocus: this.basicFocusHandler(options),
            onBlur: this.inputBlurHandler(options)
        };
    };
    FormManager.prototype.getInputValue = function (name, inputHandler) {
        var value = null;
        if (this.hasFormattedValue(name)) {
            value = this.getFormattedValue(name);
        }
        else if (this.hasParsedValue(name)) {
            value = inputHandler.format(this.getParsedValue(name));
        }
        if (this.isEmpty(value)) {
            value = '';
        }
        return value;
    };
    FormManager.prototype.file = function (name, options) {
        if (options === void 0) { options = {}; }
        options.name = name;
        options.type = 'file';
        options.inputHandler = merge_1.default({}, InputHandlers_1.fileHandler, options.inputHandler);
        return {
            type: 'file',
            name: name,
            onChange: this.fileChangeHandler(options),
            onFocus: this.basicFocusHandler(options),
            onBlur: this.basicBlurHandler(options)
        };
    };
    FormManager.prototype.inputChangeHandler = function (_a) {
        var _this = this;
        var inputHandler = _a.inputHandler, onChange = _a.onChange;
        return function (event) {
            var _a = event.target, name = _a.name, value = _a.value, required = _a.required;
            value = inputHandler.filter(value);
            var parsedValue = inputHandler.parse(value);
            var valueIsEmpty = _this.isEmpty(value);
            var valid = event.target.checkValidity() && ((valueIsEmpty && !required) || (!valueIsEmpty && inputHandler.validate(parsedValue)));
            if (onChange) {
                onChange(parsedValue, event);
            }
            _this.setParsedValue(name, parsedValue);
            _this.setFormattedValue(name, value);
            _this.setValidity(name, valid);
        };
    };
    FormManager.prototype.basicFocusHandler = function (_a) {
        var _this = this;
        var onFocus = _a.onFocus;
        return function (event) {
            var name = event.target.name;
            var parsedValue = _this.getParsedValue(name);
            if (onFocus) {
                onFocus(parsedValue, event);
            }
        };
    };
    FormManager.prototype.basicBlurHandler = function (_a) {
        var _this = this;
        var onBlur = _a.onBlur;
        return function (event) {
            var name = event.target.name;
            _this.setTouched(name, true);
            if (onBlur) {
                onBlur(_this.getParsedValue(name), event);
            }
        };
    };
    FormManager.prototype.inputBlurHandler = function (_a) {
        var _this = this;
        var inputHandler = _a.inputHandler, onBlur = _a.onBlur;
        return function (event) {
            var name = event.target.name;
            var parsedValue = _this.getParsedValue(name);
            var formattedValue = !_this.isEmpty(parsedValue) ? inputHandler.format(parsedValue) : null;
            _this.setFormattedValue(name, formattedValue);
            _this.setTouched(name, true);
            if (onBlur) {
                onBlur(parsedValue, event);
            }
        };
    };
    FormManager.prototype.inputKeyDownHandler = function (_a) {
        var _this = this;
        var name = _a.name;
        return function (_a) {
            var key = _a.key;
            if (key === 'Enter') {
                _this.setTouched(name, true);
            }
        };
    };
    FormManager.prototype.fileChangeHandler = function (_a) {
        var _this = this;
        var inputHandler = _a.inputHandler, onChange = _a.onChange;
        return function (event) {
            var _a = event.target, name = _a.name, files = _a.files;
            var valueIsEmpty = files.length == 0;
            var valid = event.target.checkValidity() && (valueIsEmpty || inputHandler.validate(files));
            var file = !valueIsEmpty && valid ? inputHandler.parse(files) : null;
            _this.setParsedValue(name, file);
            _this.setValidity(name, valid);
            if (onChange) {
                onChange(file, event);
            }
        };
    };
    FormManager.prototype.checkbox = function (name, _a) {
        var _b = _a === void 0 ? {} : _a, onChange = _b.onChange, onFocus = _b.onFocus, onBlur = _b.onBlur;
        var checked = !!this.getParsedValue(name);
        return {
            type: 'checkbox',
            name: name,
            checked: checked,
            onChange: this.checkboxChangeHandler({ onChange: onChange }),
            onFocus: this.basicFocusHandler({ onFocus: onFocus }),
            onBlur: this.basicBlurHandler({ onBlur: onBlur })
        };
    };
    FormManager.prototype.checkboxChangeHandler = function (_a) {
        var _this = this;
        var onChange = (_a === void 0 ? {} : _a).onChange;
        return function (event) {
            var name = event.target.name;
            var checked = !_this.getParsedValue(name);
            _this.setParsedValue(name, checked);
            _this.setTouched(name, true);
            _this.setValidity(name, true);
            if (onChange) {
                onChange(checked, event);
            }
        };
    };
    FormManager.prototype.radio = function (name, value, _a) {
        var _b = _a === void 0 ? {} : _a, key = _b.key, onChange = _b.onChange, onFocus = _b.onFocus, onBlur = _b.onBlur;
        return {
            type: 'radio',
            name: name,
            checked: this.isEqual(this.getParsedValue(name), value, key),
            onChange: this.radioChangeHandler({ value: value, onChange: onChange }),
            onFocus: this.basicFocusHandler({ onFocus: onFocus }),
            onBlur: this.basicBlurHandler({ onBlur: onBlur })
        };
    };
    FormManager.prototype.radioChangeHandler = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, value = _b.value, onChange = _b.onChange;
        return function (event) {
            var name = event.target.name;
            _this.setParsedValue(name, value);
            _this.setTouched(name, true);
            _this.setValidity(name, true);
            if (onChange) {
                onChange(value, event);
            }
        };
    };
    FormManager.prototype.checklist = function (name, value, _a) {
        var _b = _a === void 0 ? {} : _a, key = _b.key, onChange = _b.onChange, onFocus = _b.onFocus, onBlur = _b.onBlur;
        return {
            type: 'checkbox',
            name: name,
            checked: this.contains(this.getParsedValue(name) || [], value, key),
            onChange: this.checklistChangeHandler({ value: value, key: key, onChange: onChange }),
            onFocus: this.basicFocusHandler({ onFocus: onFocus }),
            onBlur: this.basicBlurHandler({ onBlur: onBlur })
        };
    };
    FormManager.prototype.checklistChangeHandler = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, value = _b.value, key = _b.key, onChange = _b.onChange;
        return function (event) {
            var name = event.target.name;
            var list = cloneDeep_1.default(_this.getParsedValue(name)) || [];
            var index = _this.findIndex(list, value, key);
            if (index > -1) {
                _this.delete(name, index);
                list.splice(index, 1);
            }
            else {
                _this.append(name, value);
                list.push(value);
            }
            _this.setTouched(name, true);
            _this.setValidity(name, true);
            if (onChange) {
                onChange(list, event);
            }
        };
    };
    FormManager.prototype.select = function (name, options, _a) {
        var _b = _a === void 0 ? {} : _a, key = _b.key, onChange = _b.onChange, onFocus = _b.onFocus, onBlur = _b.onBlur;
        var value = this.getParsedValue(name);
        return {
            name: name,
            value: options ? this.findIndex(options, value, key) : value,
            onChange: this.selectChangeHandler({ options: options, onChange: onChange }),
            onFocus: this.basicFocusHandler({ onFocus: onFocus }),
            onBlur: this.basicBlurHandler({ onBlur: onBlur })
        };
    };
    FormManager.prototype.selectChangeHandler = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, options = _b.options, onChange = _b.onChange;
        return function (event) {
            var _a = event.target, name = _a.name, value = _a.value;
            var parsedValue = options ? options[parseInt(value) || 0] : value;
            _this.setParsedValue(name, parsedValue);
            _this.setValidity(name, true);
            if (onChange) {
                onChange(parsedValue, event);
            }
        };
    };
    FormManager.prototype.option = function (value) {
        return {
            value: value,
        };
    };
    FormManager.prototype.get = function (name) {
        return this.getParsedValue(name);
    };
    FormManager.prototype.set = function (name, value) {
        this.setState(function (state) {
            if (isObject_1.default(name) || isFunction_1.default(name)) {
                return __assign(__assign({}, state), { values: isFunction_1.default(name) ? name(state.values) : name, formattedValues: {}, valid: {} });
            }
            if (name) {
                return __assign(__assign({}, state), { values: set_1.default(__assign({}, state.values), name, isFunction_1.default(value) ? value(get_1.default(state.values, name)) : value), formattedValues: omit_1.default(state.formattedValues, name), valid: omit_1.default(state.valid, name) });
            }
            return __assign(__assign({}, state), { values: isFunction_1.default(value) ? value(state.values) : value, formattedValues: {}, valid: {} });
        });
    };
    FormManager.prototype.getParsedValue = function (name) {
        if (name) {
            return get_1.default(this.values, name, null);
        }
        return this.values;
    };
    FormManager.prototype.hasParsedValue = function (name) {
        return this.getParsedValue(name) !== null;
    };
    FormManager.prototype.setParsedValue = function (name, value) {
        this.setState(function (state) {
            var oldValue = get_1.default(state.values, name);
            var newValue = isFunction_1.default(value) ? value(oldValue) : value;
            if (oldValue === newValue) {
                return state;
            }
            return __assign(__assign({}, state), { values: set_1.default(state.values, name, newValue) });
        });
    };
    FormManager.prototype.setParsedValues = function (values) {
        this.setState(function (state) {
            return __assign(__assign({}, state), { values: isFunction_1.default(values) ? values(state.values) : values });
        });
    };
    FormManager.prototype.getInitialValue = function (name) {
        return get_1.default(this.initialValues, name, null);
    };
    FormManager.prototype.hasInitialValue = function (name) {
        return this.getInitialValue(name) !== null;
    };
    FormManager.prototype.setInitialValue = function (name, value) {
        this.setState(function (state) {
            var oldValue = get_1.default(state.initialValues, name);
            var newValue = isFunction_1.default(value) ? value(oldValue) : value;
            if (oldValue === newValue) {
                return state;
            }
            return __assign(__assign({}, state), { initialValues: set_1.default(state.initialValues, name, newValue) });
        });
    };
    FormManager.prototype.setInitialValues = function (values) {
        this.setState(function (state) {
            return __assign(__assign({}, state), { initialValues: isFunction_1.default(values) ? values(state.initialValues) : values });
        });
    };
    FormManager.prototype.getFormattedValue = function (name) {
        return get_1.default(this.formattedValues, name, null);
    };
    FormManager.prototype.hasFormattedValue = function (name) {
        return this.getFormattedValue(name) !== null;
    };
    FormManager.prototype.setFormattedValue = function (name, value) {
        this.setState(function (state) {
            var oldValue = get_1.default(state.formattedValues, name);
            var newValue = isFunction_1.default(value) ? value(oldValue) : value;
            if (oldValue === newValue) {
                return state;
            }
            return __assign(__assign({}, state), { formattedValues: set_1.default(state.formattedValues, name, newValue) });
        });
    };
    FormManager.prototype.setFormattedValues = function (values) {
        this.setState(function (state) {
            return __assign(__assign({}, state), { formattedValues: isFunction_1.default(values) ? values(state.formattedValues) : values });
        });
    };
    FormManager.prototype.isValid = function (name) {
        if (typeof name != 'undefined') {
            return get_1.default(this.valid, name) || !has_1.default(this.valid, name);
        }
        return this.everythingIsValid();
    };
    FormManager.prototype.everythingIsValid = function (value) {
        var _this = this;
        if (value === void 0) { value = this.valid; }
        var valid = true;
        if (isObject_1.default(value)) {
            Object.keys(value).map(function (key) {
                if (valid) {
                    valid = _this.everythingIsValid(value[key]);
                }
            });
        }
        else if (value !== true) {
            valid = false;
        }
        return valid;
    };
    FormManager.prototype.setValidity = function (name, valid) {
        this.setState(function (state) {
            var oldValue = get_1.default(state.valid, name);
            var newValue = isFunction_1.default(valid) ? valid(oldValue) : valid;
            if (oldValue === newValue) {
                return state;
            }
            return __assign(__assign({}, state), { valid: set_1.default(state.valid, name, newValue) });
        });
    };
    FormManager.prototype.getTouched = function (name) {
        return get_1.default(this.touched, name, false);
    };
    FormManager.prototype.setTouched = function (name, touched) {
        this.setState(function (state) {
            var oldValue = get_1.default(state.touched, name);
            var newValue = isFunction_1.default(touched) ? touched(oldValue) : touched;
            if (oldValue === newValue) {
                return state;
            }
            return __assign(__assign({}, state), { touched: set_1.default(state.touched, name, newValue) });
        });
    };
    FormManager.prototype.changed = function (name) {
        if (typeof name != 'undefined') {
            return !this.isEqual(this.getParsedValue(name), this.getInitialValue(name));
        }
        return !this.isEqual(this.initialValues || {}, this.values || {});
    };
    FormManager.prototype.prepend = function (name, value) {
        this.setState(function (state) {
            return __assign(__assign({}, state), { values: set_1.default(state.values, name, __spreadArrays([value], get_1.default(state.values, name, []))), formattedValues: set_1.default(state.formattedValues, name, __spreadArrays([null], get_1.default(state.formattedValues, name, []))), touched: set_1.default(state.touched, name, __spreadArrays([null], get_1.default(state.touched, name, []))), valid: set_1.default(state.valid, name, __spreadArrays([null], get_1.default(state.valid, name, []))) });
        });
    };
    FormManager.prototype.append = function (name, value) {
        this.setState(function (state) {
            return __assign(__assign({}, state), { values: set_1.default(state.values, name, __spreadArrays(get_1.default(state.values, name, []), [value])) });
        });
    };
    FormManager.prototype.moveUp = function (name, index) {
        var prefix = name ? name + '.' : '';
        this.swap("" + prefix + index, "" + prefix + (index - 1));
    };
    FormManager.prototype.moveDown = function (name, index) {
        var prefix = name ? name + '.' : '';
        this.swap("" + prefix + index, "" + prefix + (index + 1));
    };
    FormManager.prototype.swap = function (first, second) {
        this.setState(function (state) {
            var value = get_1.default(state.values, first);
            var formattedValue = get_1.default(state.formattedValues, first);
            var touched = get_1.default(state.touched, first);
            var valid = get_1.default(state.valid, first);
            set_1.default(state.values, first, get_1.default(state.values, second));
            set_1.default(state.formattedValues, first, get_1.default(state.formattedValues, second));
            set_1.default(state.touched, first, get_1.default(state.touched, second));
            set_1.default(state.valid, first, get_1.default(state.valid, second));
            set_1.default(state.values, second, value);
            set_1.default(state.formattedValues, second, formattedValue);
            set_1.default(state.touched, second, touched);
            set_1.default(state.valid, second, valid);
            return __assign({}, state);
        });
    };
    FormManager.prototype.splice = function (name, index, count) {
        this.setState(function (state) {
            var lists = [
                get_1.default(state.values, name),
                get_1.default(state.formattedValues, name),
                get_1.default(state.touched, name),
                get_1.default(state.valid, name)
            ];
            lists.map(function (list) {
                if (isArray_1.default(list)) {
                    list.splice(index, count);
                }
            });
            return __assign({}, state);
        });
    };
    FormManager.prototype.delete = function (name, index) {
        if (typeof index != 'undefined') {
            this.splice(name, index, 1);
        }
        else {
            this.setState(function (state) {
                unset_1.default(state.values, name);
                unset_1.default(state.formattedValues, name);
                unset_1.default(state.touched, name);
                unset_1.default(state.valid, name);
                return __assign({}, state);
            });
        }
    };
    FormManager.prototype.reset = function (name) {
        var _this = this;
        this.setState(function (state) {
            if (isObject_1.default(name) || isFunction_1.default(name)) {
                return __assign(__assign({}, state), { values: isFunction_1.default(name) ? name(state.values) : name, initialValues: cloneDeep_1.default(isFunction_1.default(name) ? name(state.initialValues) : name), formattedValues: {}, touched: {}, valid: {} });
            }
            if (name) {
                return __assign(__assign({}, state), { values: set_1.default(__assign({}, state.values), name, cloneDeep_1.default(get_1.default(state.initialValues, name, null))), formattedValues: omit_1.default(state.formattedValues, name), touched: omit_1.default(state.touched, name), valid: omit_1.default(state.valid, name) });
            }
            return __assign(__assign({}, state), { values: cloneDeep_1.default(_this.initialValues), formattedValues: {}, touched: {}, valid: {} });
        });
    };
    FormManager.prototype.isEqual = function (a, b, key) {
        if (typeof key != 'undefined' && a !== null && b !== null) {
            return isEqual_1.default(a[key], b[key]);
        }
        return isEqual_1.default(a, b);
    };
    FormManager.prototype.findIndex = function (list, value, key) {
        var _this = this;
        var index = -1;
        list.map(function (item, i) {
            if (_this.isEqual(item, value, key)) {
                index = i;
            }
        });
        return index;
    };
    FormManager.prototype.contains = function (list, value, key) {
        return this.findIndex(list, value, key) > -1;
    };
    FormManager.prototype.isEmpty = function (value) {
        return typeof value == 'undefined' || value === '' || value === null;
    };
    return FormManager;
}());
exports.default = FormManager;
